import { render, staticRenderFns } from "./DatesSystem.vue?vue&type=template&id=eed5e560&scoped=true"
import script from "./DatesSystem.vue?vue&type=script&lang=js"
export * from "./DatesSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed5e560",
  null
  
)

export default component.exports